import React, { useState, useEffect } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import { Notification } from '../../../Constant';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import TailChase from '../../../Components/Loaders/TailChase';
import { Alert } from 'reactstrap';
import { useUserMutations } from '../../../mutations';
import { AnimatePresence, motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';
import ScrollBar from 'react-perfect-scrollbar';

const Notificationbar = ({ data, loading, error }) => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const { markNotificationAsReadMutation, markAllNotificationsAsReadMutation } = useUserMutations();
  const [visibleNotifications, setVisibleNotifications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(data)) {
      setVisibleNotifications(data);
    }
  }, [data]);

  const handleMarkAsRead = (notification) => {
    markNotificationAsReadMutation.mutate(notification.id, {
      onSuccess: () => {
        setVisibleNotifications((prev) => prev.filter((n) => n.id !== notification.id));
        // Navigate to the appropriate page based on the notification type
        if (notification.type === 'New Course') {
          navigate(`/app/courses/${notification.data.course_id}`);
        } else if (notification.type === 'New Chapter' || notification.type === 'New Lesson' || 
                   notification.type === 'New Resource' || notification.type === 'New Exercice') {
          navigate(`/app/chapter/${notification.data.chapter_id}`);
        }
      },
    });
  };

  const handleMarkAllAsRead = () => {
    if (!visibleNotifications.length) return;
    markAllNotificationsAsReadMutation.mutate(undefined, {
      onSuccess: () => {
        setVisibleNotifications([]);
      },
    });
  };

  if (loading) return <TailChase />;
  if (error) return <Alert color='danger'>{error.message}</Alert>;

  return (
    <li className='onhover-dropdown'>
      <div className='notification-box' onClick={() => setNotificationDropDown(!notificationDropDown)}>
        <SvgIcon iconId='notification' />
        <span className='badge rounded-pill badge-info'>{visibleNotifications.length}</span>
      </div>
      <div className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}>
        <h6 className='f-18 mb-0 dropdown-title'>{Notification}</h6>
        <ScrollBar style={{ maxHeight: '300px' }}>
          <ul>
            {visibleNotifications.length > 0 && (
              <li>
                <button type='button' className='f-w-700 btn btn-link p-0 border-0' onClick={handleMarkAllAsRead}>
                  Marquer tout comme lu
                </button>
              </li>
            )}
            <AnimatePresence initial={false}>
              {visibleNotifications.map(notification => (
                <motion.li
                  key={notification.id}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  whileHover={{ scale: 1.05 }}
                  className={notification.read_at ? 'b-l-primary border-4' : 'b-l-info border-4'}
                  onClick={() => handleMarkAsRead(notification)}
                >
                  <p>
                    {notification.type} - {notification.data.course_title || 
                                         notification.data.chapter_title || 
                                         notification.data.lesson_title || 
                                         notification.data.pdf_title ||
                                         notification.data.exercise_title}
                    <span className='font-danger'>
                      {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true, locale: fr })}
                    </span>
                  </p>
                </motion.li>
              ))}
            </AnimatePresence>
            {/* <li>
              <a className='f-w-700' href='#javascript'>
                {CHECKALL}
              </a>
            </li> */}
          </ul>
        </ScrollBar>
      </div>
    </li>
  );
};

export default Notificationbar;